export default "__VITE_ASSET__Gjuw424G__"